import React from 'react'
import styles from './styles.module.scss'

export default function DashboardSidebar() {

  return (
      <div className={styles.root}>
          <p><strong>Dashboard menu</strong></p>
          <ul className={styles.menu}>
              <li>
                  <div className={styles.dataType}>
                      Stats
                  </div>
              </li>
              <li>
                  <div>
                      Notifications
                  </div>
              </li>
              <li>
                  <div>
                      My tasks
                  </div>
              </li>
              <li>
                  <div>
                      New applications
                  </div>
              </li>
              <li>
                  <div>
                      Recently added objects
                  </div>
              </li>
          </ul>
      </div>

  )

}
